import { render } from "./DonationGroupManageCreatePage.vue?vue&type=template&id=57f83035&lang=true"
import script from "./DonationGroupManageCreatePage.vue?vue&type=script&lang=js"
export * from "./DonationGroupManageCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__